import { GlassCard, PageHeader } from "../components/shared";
import { Coins, Download, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Payroll() {
    const payslips = [
        { month: "May 2026", basic: "₹65,000", bonus: "₹5,000", total: "₹70,000", status: "Paid" },
        { month: "April 2026", basic: "₹65,000", bonus: "₹0", total: "₹65,000", status: "Paid" },
        { month: "March 2026", basic: "₹62,000", bonus: "₹10,000", total: "₹72,000", status: "Paid" }
    ];

    const downloadPayslip = (p) => {
        toast.loading(`Downloading payslip for ${p.month}...`, { id: "payslip-download" });
        // Generate a mock payslip text file
        const content = `
================================================
               PARSHHR PAYSLIP                  
================================================
Company:      ParshWebCraft
Period:       ${p.month}
Basic Salary: ${p.basic}
Bonus Paid:   ${p.bonus}
Total Paid:   ${p.total}
Status:       ${p.status}
Generated on: ${new Date().toLocaleDateString()}
================================================
        `;
        try {
            const blob = new Blob([content], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `payslip_${p.month.replace(/\s+/g, '_')}.txt`;
            link.click();
            toast.success(`Payslip for ${p.month} downloaded`, { id: "payslip-download" });
        } catch (e) {
            toast.error("Failed to download payslip", { id: "payslip-download" });
        }
    };

    return (
        <div>
            <PageHeader title="Payroll & Salary" subtitle="View salary breakdown, allowances, and download payslips." />
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <GlassCard className="p-6 lg:col-span-2 border border-teal-100/50 dark:border-teal-900/50">
                    <h3 className="font-heading font-bold text-lg mb-4 text-slate-800 dark:text-slate-100 flex items-center gap-2">
                        <Coins className="w-5 h-5 text-teal-600" />
                        Payslip History
                    </h3>
                    
                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse text-sm">
                            <thead>
                                <tr className="border-b border-black/5 dark:border-white/5 text-muted-foreground font-semibold">
                                    <th className="pb-3">Month</th>
                                    <th className="pb-3">Basic</th>
                                    <th className="pb-3">Bonus</th>
                                    <th className="pb-3">Total Paid</th>
                                    <th className="pb-3">Status</th>
                                    <th className="pb-3 text-right">Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-black/5 dark:divide-white/5">
                                {payslips.map((p, i) => (
                                    <tr key={i} className="hover:bg-slate-50/50 dark:hover:bg-slate-900/10">
                                        <td className="py-3.5 font-medium">{p.month}</td>
                                        <td className="py-3.5">{p.basic}</td>
                                        <td className="py-3.5">{p.bonus}</td>
                                        <td className="py-3.5 font-semibold text-teal-600">{p.total}</td>
                                        <td className="py-3.5">
                                            <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-200 dark:bg-emerald-950/20 dark:text-emerald-400">
                                                {p.status}
                                            </span>
                                        </td>
                                        <td className="py-3.5 text-right">
                                            <button onClick={() => downloadPayslip(p)} className="p-1.5 rounded-lg hover:bg-teal-50 dark:hover:bg-teal-950/30 text-teal-600 border border-teal-200/50 dark:border-teal-800/30 transition inline-flex items-center gap-1">
                                                <Download className="w-4 h-4" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </GlassCard>
                
                <div className="space-y-6">
                    <GlassCard className="p-6 border border-teal-100/50 dark:border-teal-900/50">
                        <h3 className="font-heading font-bold text-lg mb-4 text-slate-800 dark:text-slate-100 flex items-center gap-2">
                            <ShieldCheck className="w-5 h-5 text-emerald-500" />
                            Tax & PF Details
                        </h3>
                        <div className="space-y-3 text-sm">
                            <div className="flex justify-between">
                                <span className="text-muted-foreground">PAN Registered</span>
                                <span className="font-semibold uppercase">ABCDE1234F</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-muted-foreground">Provident Fund (PF)</span>
                                <span className="font-semibold">Enabled</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-muted-foreground">Tax Regime</span>
                                <span className="font-semibold">New Regime</span>
                            </div>
                        </div>
                    </GlassCard>
                </div>
            </div>
        </div>
    );
}
